import React from 'react'
import IconFromString from '../../IconFromString'

type DetailsCardIconProps = {
  icon: string
  title: string
  text: string
}

export default function DetailsCardIcon({
  icon,
  title,
  text,
}: DetailsCardIconProps) {
  return (
    <div className="border-1 h-full rounded-2xl border-brandLightBlue bg-neutralWhite px-4 py-4">
      <div className="pb-2">
        <IconFromString
          iconName={icon}
          className="h-8 text-brandLightBlue md:h-10"
        />
      </div>
      <div>
        <div className="text-xl font-medium text-brandLightBlue">{title}</div>
        <div className="text-justify text-sm text-neutralBlack">{text}</div>
      </div>
    </div>
  )
}
